<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style1', { sticky: isSticky }]">
      <div class="header-top">
        <div class="container">
          <TopHeader />
        </div>
      </div>
      <MainNavbarPages />
    </div>

    <div class="content-wrapper">
      <div class="service-details-wrap ptb-50">
        <div class="container">
          <div class="row">
            <div class="col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
              <SideBar />
            </div>

            <div class="col-xl-8 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
              <div class="service-desc">

                <div class="row">
                  <div class="col-md-9">
                    <h2>Dr. Alexandra Ioana Năstasă – Medic specialist cardiolog</h2>
                    <div class="other-option md-none mt-40">
                      <a href="/#appointment" class="btn style2">
                        Solicită o programare
                      </a>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="team-card style3">
                      <div class="team-img">
                        <img src="../../../assets/images/team/member-9.jpg" alt="Dr. Alexandra Ioana Năstasă – Cardiologie" />
                      </div>
                    </div>
                  </div>
                </div>

                <p>
                  Sunt <strong>Dr. Năstasă Ioana-Alexandra</strong>, medic specialist în Cardiologie. Mi-am dorit să contribui cu empatie, comunicare deschisă și grijă la prevenirea, diagnosticarea și tratamentul bolilor cardiovasculare și de a fi alături de pacienți în acest proces medical, așadar am ales această specialitate.
                </p>
                <p>
                  Consider că o evaluare cardiologică corectă înseamnă mai mult decât identificarea unei afecțiuni: înseamnă înțelegerea pacientului în ansamblu, evaluarea factorilor de risc cardiovascular și identificarea precoce a modificărilor care pot influența sănătatea cordului pe termen lung.
                </p>
                <p>
                  În activitatea mea pun accent pe diagnosticul precoce, prevenția cardiovasculară, monitorizarea atentă a pacienților și individualizarea conduitei medicale, în acord cu recomandările și ghidurile actuale.
                </p>

                <ul class="content-feature-list style5 list-style">
                  <li>
                    <i class="ri-check-double-line"></i>Diagnosticul precoce și prevenția cardiovasculară
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Evaluarea factorilor de risc cardiovascular
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Managementul și monitorizarea patologiei cardiace acute și cronice
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Interpretarea investigațiilor cardiologice
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Individualizarea conduitei medicale conform ghidurilor actuale
                  </li>
                </ul>

                <h3>Educație și formare profesională</h3>
                <p>
                  Medicina este un domeniu în continuă evoluție, iar formarea profesională continuă reprezintă o parte importantă a activității mele. Consider că actualizarea permanentă a cunoștințelor și familiarizarea cu cele mai noi recomandări și metode de diagnostic și tratament sunt esențiale pentru oferirea unor servicii medicale de calitate.
                </p>

                <ul class="content-feature-list style5 list-style">
                  <li>
                    <i class="ri-check-double-line"></i>
                    <strong>2019–2026</strong> – Rezidențiat în Cardiologie, în cadrul mai multor centre medicale: Spitalul Clinic Județean de Urgență Târgu Mureș, Spitalul Clinic Județean de Urgență „Sf. Spiridon” Iași, Spitalul Clinic de Recuperare Iași
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>
                    <strong>2012–2018</strong> – Facultatea de Medicină Generală, Universitatea de Medicină și Farmacie „Grigore T. Popa” din Iași
                  </li>
                </ul>

                <h3>Experiență profesională</h3>
                <p>
                  Pe parcursul pregătirii în specialitatea Cardiologie am avut oportunitatea de a lucra în centre medicale cu profil și patologie cardiovasculară variată, experiență care mi-a permis să îmi dezvolt o abordare complexă a pacientului cardiologic.
                </p>

                <ul class="content-feature-list style5 list-style">
                  <li>
                    <i class="ri-check-double-line"></i>
                    Evaluarea pacienților cu patologie cardiovasculară acută și cronică
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>
                    Interpretarea investigațiilor cardiologice și stabilirea conduitei terapeutice
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>
                    Atenție deosebită acordată prevenției și monitorizării pe termen lung
                  </li>
                </ul>

              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
    <MainFooter />
  </div>
</template>

<script>
import TopHeader from "../../Layouts/TopHeader.vue";
import MainNavbarPages from "../../Layouts/MainNavbarPages.vue";
import SideBar from "./SideBar.vue";
// import ServiceDetails from "../../ServiceDetails/ServiceDetails.vue";
import MainFooter from "../../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "CardiologiePage",
  components: {
    TopHeader,
    SideBar,
    MainNavbarPages,
    // ServiceDetails,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      let scrollPos = window.scrollY;
      if (scrollPos >= 100) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    });
  },
});
</script>